import React from "react";
import { WifiHigh, WifiSlash, ArrowsClockwise } from "@phosphor-icons/react";
import { useConnectivity } from "../context/ConnectivityContext";

// Restrained global connectivity pill. Hidden while healthy online to avoid clutter.
export default function ConnectivityIndicator() {
  const { status } = useConnectivity();
  if (status === "online") return null;

  const cfg =
    status === "reconnecting"
      ? { icon: ArrowsClockwise, text: "Reconnecting…", cls: "border-ff-gold/50 text-ff-gold", spin: true }
      : { icon: WifiSlash, text: "Offline", cls: "border-ff-danger/60 text-red-300", spin: false };
  const Icon = cfg.icon;

  return (
    <div
      data-testid="connectivity-indicator"
      data-status={status}
      className={`fixed bottom-4 left-1/2 z-[9996] -translate-x-1/2 rounded-full border bg-ff-bg2/90 px-3 py-1.5 text-xs font-medium shadow-lg backdrop-blur ${cfg.cls}`}
    >
      <span className="flex items-center gap-1.5">
        <Icon size={14} weight="bold" className={cfg.spin ? "animate-spin" : ""} /> {cfg.text}
      </span>
    </div>
  );
}
